import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import Layout from "./Shared/Layout";
import FilterByPrice from "./Shared/FilterByPrice";
import RatingAndWishlist from "./Shared/RatingAndWishList";
import { useWishlist } from "../context/wishlistContext";
import ServicesSection from "./HomePage/ServicesSection";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const ProductBySubCategoryId = () => {
    const productSubCategoryId = Number(localStorage.getItem('productSubCategoryId'));
    const loginId = localStorage.getItem('loginId');
    const [productBySubCategoryId, setProductBySubCategoryId] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedPriceRanges, setSelectedPriceRanges] = useState([]);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { addToWishlist, removeFromWishlist } = useWishlist();
    const [wishListForm, setWishListForm] = useState({
        wishProductId: 0,
        loginId: loginId ? Number(loginId) : 0,
        productId: 0,
        isActive: true,
        createdBy: 0
    });

    const GetProductDetailBySubCategoryId = useCallback(async () => {
        try {
            const response = await get(API_URL.GetProductDetail);
            if (response.isSuccess === 200) {
                const filteredData = response?.data?.filter(product =>
                    product.isDisplay &&
                    (
                        product.productSubCategoryId === productSubCategoryId ||
                        (product.rsubCategoryId &&
                            product.rsubCategoryId.split(',').includes(String(productSubCategoryId)))
                    )
                );
                setProductBySubCategoryId(filteredData);
            } else {
                setProductBySubCategoryId([]);
            }
        } catch (error) {
            setProductBySubCategoryId([]);
        } finally {
            setLoading(false);
        }
    }, [productSubCategoryId]);

    useEffect(() => {
        GetProductDetailBySubCategoryId();
    }, [GetProductDetailBySubCategoryId]);

    const truncateProductName = (productBySubCategoryId, maxChars = 35) => {
        if (!productBySubCategoryId) return '';
        if (productBySubCategoryId.length <= maxChars) {
            return productBySubCategoryId;
        }
        return `${productBySubCategoryId.slice(0, maxChars)}...`;
    };

    const onProductDetail = (item) => {
        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');

        const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
        const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

        if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
        }
        localStorage.setItem('productId', item?.productId);

        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
        sessionStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}/${item?.productName.replace(/\s+/g, '_')}/${item?.productId}`);
    }

    // filter and short data function all

    const [selectedSort, setSelectedSort] = useState('default');

    const handleSortChange = (e) => {
        setSelectedSort(e.target.value);
    };

    const handlePriceCheckboxChange = (priceRange) => {
        const updatedSelectedPriceRanges = selectedPriceRanges.includes(priceRange)
            ? selectedPriceRanges.filter(range => range !== priceRange)
            : [...selectedPriceRanges, priceRange];

        setSelectedPriceRanges(updatedSelectedPriceRanges);
    };

    useEffect(() => {
        if (productBySubCategoryId && productBySubCategoryId.length > 0) {
            let filtered = productBySubCategoryId.filter(product => {
                // Filter by selected categories
                const isInCategory = selectedCategories.length === 0 || selectedCategories.includes(product.productCategoryId);

                // Filter by selected price range
                const isInPriceRange = selectedPriceRanges.length === 0 || selectedPriceRanges.some(range => {
                    switch (range) {
                        case '0-999':
                            return product.unitPrice >= 0 && product.unitPrice <= 999;
                        case '999-1499':
                            return product.unitPrice >= 999 && product.unitPrice <= 1499;
                        case '1499-1999':
                            return product.unitPrice >= 1499 && product.unitPrice <= 1999;
                        case '1999-2499':
                            return product.unitPrice >= 1999 && product.unitPrice <= 2499;
                        case '2499+':
                            return product.unitPrice >= 2499;
                        default:
                            return true;
                    }
                });

                return isInCategory && isInPriceRange;
            });

            // Apply sorting based on selected sort option
            if (selectedSort === "priceLowToHigh") {
                filtered.sort((a, b) => a.unitPrice - b.unitPrice);
            } else if (selectedSort === "priceHighToLow") {
                filtered.sort((a, b) => b.unitPrice - a.unitPrice);
            } else if (selectedSort === "rating") {
                filtered.sort((a, b) => b.rating - a.rating);
            }

            setFilteredProducts(filtered);
        }
    }, [selectedCategories, selectedPriceRanges, productBySubCategoryId, selectedSort]);

    const handleClearFilters = () => {
        setSelectedCategories([]);
        setSelectedPriceRanges([]);
        setSelectedSort("default");
    };

    const toggleSidebar = () => {
        setIsSidebarVisible(prevState => !prevState);
    };

    const onWishlistToggle = async (item) => {
        if (loginId) {
            const updatedWishListForm = {
                ...wishListForm,
                productId: item?.productId || 0
            };

            setWishListForm(updatedWishListForm);

            if (item.wishStatus) {
                await removeFromWishlist(item);
                GetProductDetailBySubCategoryId();
                toast.success('Remove to wishlist!');
            } else {
                await addToWishlist(updatedWishListForm);
                GetProductDetailBySubCategoryId();
                toast.success('Add to wishlist!');
            }
        } else {
            navigate('/login');
        }
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    console.log(filteredProducts,'filteredProducts')

    return (
        <Layout>
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <section className="same_space layout_main">
                <div className="container">
                    <div className="hedding_product row justify-content-end align-items-end">
                        <div className="icon_wepper_filter col-md-12 col-7 d-sm-flex align-items-center justify-content-sm-end">
                            <h6 className="mb-1" style={{ paddingRight: '10px' }}>Sort by : </h6>
                            <div>
                                <select
                                    defaultValue="default"
                                    value={selectedSort}
                                    onChange={handleSortChange}
                                    className="sort_by_select"
                                >
                                    <option value="default">All</option>
                                    <option value="priceLowToHigh">Low to High</option>
                                    <option value="priceHighToLow">High to Low</option>
                                </select>
                            </div>
                        </div>
                        <div className="filter_toggle_mobile col-5">
                            <button onClick={toggleSidebar}>Filter
                                <span><svg
                                    id="Layer_1"
                                    height="22"
                                    width="22"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g width="100%" height="100%" transform="matrix(1,0,0,1,0,0)">
                                        <switch>
                                            <g>
                                                <path
                                                    d="m18 24h-12c-3.3 0-6-2.7-6-6v-12c0-3.3 2.7-6 6-6h12c3.3 0 6 2.7 6 6v12c0 3.3-2.7 6-6 6z"
                                                    fill="#ffffff" // Green fill
                                                />
                                                <path
                                                    d="m12 15.5c-.2 0-.5-.1-.6-.2l-6-5c-.4-.4-.5-1-.1-1.4s1-.5 1.4-.1l5.4 4.5 5.4-4.3c.4-.3 1.1-.3 1.4.1.4.4.3 1-.1 1.4 0 0 0 0-.1 0l-6 4.8c-.3.2-.5.2-.7.2z"
                                                    fill="#000000" // White fill
                                                />
                                            </g>
                                        </switch>
                                    </g>
                                </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="row mt-sm-4 mt-2">
                        <div className={`col-md-3 col-12 filter_sidebar ${isSidebarVisible ? 'show' : 'hide'}`}>
                            <FilterByPrice
                                selectedPriceRanges={selectedPriceRanges}
                                handlePriceCheckboxChange={handlePriceCheckboxChange}
                                handleClearFilters={handleClearFilters}
                                setIsSidebarVisible={setIsSidebarVisible}
                            />
                        </div>
                        <div className="col-md-9 col-12">
                            {filteredProducts !== null ? (
                                filteredProducts.length > 0 ? (
                                    <div className="shop_flex_weppr row">
                                        {filteredProducts?.map((item, index) => {
                                            // const discountPercent = calculateDiscountPercent(item.mrp, item.unitPrice);
                                            const rating = item.avgRatting;

                                            return (
                                                <div key={index} className="shop_inner col-lg-3 col-sm-4 col-6 mb-sm-4 mb-0 pb-sm-4 pb-3">
                                                    {item?.productImageDtos?.length > 0 ? (
                                                        item.productImageDtos.some(image => image.isHeader) ? (
                                                            item.productImageDtos.map((image, j) => (
                                                                image.isHeader ? (
                                                                    <div key={`${index}-${j}`} onClick={() => onProductDetail(item)}>
                                                                        <img className="curser-pointer" src={`${imageurl}${image?.imgPath}`} alt={item?.productName} style={{ width: '100%' }} />
                                                                        <h5 className="curser-pointer product_display_name mb-0" title={item?.productName}>{truncateProductName(item?.displayName)}</h5>
                                                                    </div>
                                                                ) : null
                                                            ))
                                                        ) : (
                                                            <div key={`${index}-0`} onClick={() => onProductDetail(item)}>
                                                                <img className="curser-pointer"
                                                                    src={item.productImageDtos[0]?.imgPath ? `${imageurl}${item.productImageDtos[0]?.imgPath}` : '../images/defaultImage.png'}
                                                                    alt={item?.productName}
                                                                    style={{ width: '100%' }}
                                                                />
                                                                <h5 className="curser-pointer product_display_name mb-0" title={item?.productName}>{truncateProductName(item?.displayName)}</h5>
                                                            </div>
                                                        )
                                                    ) : (
                                                        <div key={`${index}-default`} onClick={() => onProductDetail(item)}>
                                                            <img className="curser-pointer" src="../images/defaultImage.png" alt={item?.productName} style={{ width: '100%' }} />
                                                            <h5 className="curser-pointer product_display_name mb-0" title={item?.productName}>{truncateProductName(item?.displayName)}</h5>
                                                        </div>
                                                    )}
                                                    <RatingAndWishlist
                                                        item={item}
                                                        rating={rating}
                                                        onWishlistToggle={onWishlistToggle}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <p className="error_img">
                                        <img src="../images/Error1.png" alt="" />
                                    </p>
                                )
                            ) : (
                                loading ?
                                    <p>Loading...</p> : null
                            )}
                        </div>
                    </div>
                </div>
                <div className="mt-5">
                    <ServicesSection />
                </div>
            </section>
        </Layout>
    )
}

export default ProductBySubCategoryId;